import { ENTITLEMENTS as T } from "./entitlements.js";
var E = /* @__PURE__ */ ((S) => (S.CUSTOM_FOODS = "CUSTOM_FOODS", S.CUSTOM_SERVING_UNITS = "CUSTOM_SERVING_UNITS", S.CUSTOM_EXERCISES = "CUSTOM_EXERCISES", S.CUSTOM_MUSCLE_TARGETS = "CUSTOM_MUSCLE_TARGETS", S.MACRO_TARGETS = "MACRO_TARGETS", S.UNLIMITED_HISTORY = "UNLIMITED_HISTORY", S.MCP_ACCESS = "MCP_ACCESS", S))(E || {});
const _ = {
  CUSTOM_FOODS: T.pro,
  CUSTOM_SERVING_UNITS: T.pro,
  CUSTOM_EXERCISES: T.pro,
  CUSTOM_MUSCLE_TARGETS: T.pro,
  MACRO_TARGETS: T.pro,
  UNLIMITED_HISTORY: T.pro,
  MCP_ACCESS: T.ai
};
export {
  _ as FEATURE_REQUIREMENTS,
  E as Feature
};
